(() => {
  const initializedClass = 'ng-horizontal-filters-initialized'
  let closingFromOutside = false

  function initHorizontalFilters(root = document) {
    root.querySelectorAll('[data-horizontal-collection-filters]').forEach((container) => {
      if (container.classList.contains(initializedClass) || !window.MinimogLibs?.Accordion) return

      const form = container.querySelector('form')
      if (!form) return

      container.classList.add(initializedClass)
      new window.MinimogLibs.Accordion(form, { presetContentHeight: true })
    })
  }

  function scheduleInit(root) {
    window.requestAnimationFrame(() => initHorizontalFilters(root))
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleInit(document), { once: true })
  } else {
    scheduleInit(document)
  }

  document.addEventListener('collection:rerendered', () => scheduleInit(document))

  document.addEventListener('click', (event) => {
    if (closingFromOutside) return

    const activeWidget = event.target.closest(
      '[data-horizontal-collection-filters] .m-filter--widget.open'
    )
    const openWidgets = document.querySelectorAll(
      '[data-horizontal-collection-filters] .m-filter--widget.open'
    )

    closingFromOutside = true
    openWidgets.forEach((widget) => {
      if (widget === activeWidget) return
      widget.querySelector(':scope > .m-filter--widget-title')?.dispatchEvent(
        new MouseEvent('click', { bubbles: true })
      )
    })
    closingFromOutside = false
  })

  document.addEventListener('click', (event) => {
    const sortOption = event.target.closest('[data-sort-option]')
    if (!sortOption) return

    event.preventDefault()
    const index = sortOption.dataset.index
    if (index === undefined) return

    const section = sortOption.closest('.facest-filters-section') || document
    const toolbarSelect = section.querySelector('[data-toolbar-sorting] select')
    const formSelect = section.querySelector('[data-form-sorting] select')
    const form = section.querySelector('#CollectionFiltersForm')

    const widget = sortOption.closest('.m-filter--widget.open')
    if (widget) {
      widget.querySelector(':scope > .m-filter--widget-title')?.dispatchEvent(
        new MouseEvent('click', { bubbles: true })
      )
    }

    if (toolbarSelect && toolbarSelect.selectedIndex !== Number(index)) {
      toolbarSelect.selectedIndex = Number(index)
      toolbarSelect.dispatchEvent(new Event('change', { bubbles: true }))
    } else if (formSelect && form && formSelect.selectedIndex !== Number(index)) {
      formSelect.selectedIndex = Number(index)
      form.dispatchEvent(new Event('input', { bubbles: true }))
    }
  })
})()
